module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.636aa5ac.png";